import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiDialog } from 'ui-components';
import { marginRight } from 'utils';

export const StyledContentExport = styled('div')(
  () => css`
    button {
      ${marginRight('16px')}
      span {
        display: flex;
        gap: 8px;
        align-items: center;
      }
    }
  `
);

export const StyledContentExportDialog = styled(UiDialog)(
  () => css`
    &.content-export-modal {
      .content-export-title {
        padding: 12px 20px !important;

        .title-content {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;
          min-width: 0;
        }

        .title-back-link {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px 8px !important;
          min-width: auto;
          padding: 0;
          line-height: 0;
        }

        .title-text {
          font-size: 0.875rem;
          font-weight: 700;
          line-height: 1.5rem;
          color: #0c395a;
        }
      }

      .content-export-body {
        padding: 16px 20px !important;

        .label {
          font-size: 0.75rem;
          font-weight: 700;
          line-height: 1.5rem;
        }

        .content-export-type-subtitle {
          font-size: 12px;
          font-weight: 700;
          line-height: 24px;
          margin-bottom: 16px;
          color: #222222;
        }

        .export-content-fields {
          .export-content-field {
            width: 35%;
          }
        }
      }

      .content-export-actions {
        &.excel-actions {
          justify-content: space-between;
        }

        &.bulletin-actions {
          justify-content: flex-end;
        }

        button {
          min-width: 100px;
          margin: 0;

          &.action-advanced-button {
            margin-right: 0 !important;
          }
        }
      }
    }
  `
);
